export const initialState = {
    userInfo:{firstName:'',lastName:'',photoUrl:''},
    myPosts:[],
    // modals
    approvalModal:{
        open:false,
        detail:''
    },
    editPostModal:{
        open:false,
        detail:''
    },
    interestsModal:{
        open:false,
        detail:'',
        isFirstLogin:false
    },
    postLikesModal:{
        open:false,
        isPostLike:true,
        id:null,
        commentId:null
    }
}